export default __webpack_public_path__ + "static/media/0042.8e4cadf9.png";